export enum IndividualDirectorFormSteps {
  PERSONAL_DETAILS = 0,
  PASSPORT_INFO = 1,
  DOCUMENTS = 2,
}

enum IndividualDirectorFormStepsStatus {
  INACTIVE,
  ACTIVE,
  COMPLETED,
}
